import React, { FC, useCallback } from 'react';
import { fetchPositionTypes, LoadMoreSelect } from '@erecruit/modules';
import InfoContainer from './InfoContainer';

interface PositionTypePickerProps {
  onChange: (selectedIds: number[]) => void;
  defaultSelection: number[];
}

const PositionTypePicker: FC<PositionTypePickerProps> = props => {
  const { onChange, defaultSelection } = props;
  const getDefaultSelectionFilter = useCallback(() => {
    return {
      ids: defaultSelection,
    };
  }, [defaultSelection]);

  return (
    <InfoContainer
      messageId={messageIds.vms.settings.data.emptyPositionTypesWarning}
      displayInfo={getDefaultSelectionFilter().ids.length === 0}
    >
      <LoadMoreSelect
        fetchEntities={fetchPositionTypes}
        onChange={onChange}
        defaultSelection={defaultSelection}
        getDefaultSelectionFilter={getDefaultSelectionFilter}
      />
    </InfoContainer>
  );
};

export { PositionTypePicker };
